import React, { useEffect } from "react";
import { Col, Row } from "antd";
import CardDetailsProject from "../../../components/card-details-project/CardDetailsProject";
import HeroSectionDetailsProject from "./HeroSectionDetailsProject";
import headerBg from "../../../assets/images/seasonal-projects.png";
import DonationCard from "../../../biblio/Cards/DonationCard";
import { getDonationTypes } from "../../../apis/actions/donation.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import OtherProjectsCard from "./OtherProjectsCard";
import NavBar from "../../communs/NavBar";
import FooterSection from "../../../components/sections/FooterSection";
import Loader from "../../../biblio/Loader/Loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getDetailsProjects } from "../../../apis/actions/projects.actions";
import headerMobileBg from "../../../assets/background/seasonal-projects-Mob.jpg";
import Seo from "../../../components/seo/Seo";
const LayoutDetailsProject = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const location = useLocation();
  const donationAmount = location.state?.donationAmount;
  const counter = location.state?.counter;
  const selectedShare = location.state?.selectedShare;
  const selectedDonation = location.state?.selectedDonation;

  const { project: detailProject, status } = useSelector(
    (state: RootState) => state.projects.detailsProject
  );
  useEffect(() => {
    if (status === "idle" || String(detailProject?.id) !== id) {
      dispatch(getDetailsProjects(id));
    }
    dispatch(getDonationTypes());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (
      detailProject &&
      status === "succeeded" &&
      Object.keys(detailProject).length === 0
    ) {
      navigate("/");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailProject]);

  if (status === "loading") {
    return (
      <>
        <Loader />
      </>
    );
  }

  const handleClick = (body: any) => {
    console.log(body);
  };
  return (
    <div className="takaful--layout-details">
      <Seo
        title={detailProject?.project_name}
        description={detailProject?.brief}
        image={
          detailProject?.title_image_ids?.[0] ??
          detailProject?.detail_image_ids?.[0]
        }
      />
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="المشاريع"
        subTitle="تفاصيل المشروع"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"المشاريع"}
      />
      <Row dir="rtl" justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={14}
          xl={14}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <CardDetailsProject project={detailProject} type="المشاريع" />
        </Col>
        <Col
          xxl={7}
          xl={7}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          {detailProject && (
            <DonationCard
              handleClick={handleClick}
              donationAmounts={[]}
              variant="payment"
              donationAmount={donationAmount}
              requirePhoneNumber
              counter={counter}
              selectedShare={selectedShare}
              selectedDonation={selectedDonation}
              donationTypes={detailProject?.donation_type_ids}
              remainingAmount={detailProject?.residual_amount}
              share_ids={detailProject?.share_ids ?? []}
              className="takaful--donation-details"
              project={detailProject}
              type="المشاريع"
            />
          )}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>
      <OtherProjectsCard />
      <FooterSection />
    </div>
  );
};

export default LayoutDetailsProject;
